import { colors } from 'context/theme-context'

const InputSubtitle: React.FC = (props) => (
  <div style={{ marginTop: '0.225rem', fontSize: '0.75rem', color: colors.gray7 }}>
    {props.children}
  </div>
)

export default InputSubtitle
